<template>
  <el-drawer :title="title" size="70%" custom-class="deviceDrawer cloudsceneDrawer" :visible.sync="drawer"
    direction="rtl">
    <div class="drawer-view">
      <Step :stepIndex="stepIndex"></Step>
      <div class="center-view">
        <TriggerList :triggerTypeList="triggerTypeList" :timingTypeList="timingTypeList" :weekTypeList="weekTypeList"
          ref="TriggerList" v-if="stepIndex == 1" :triggerList="triggerList" :conditionType="conditions"
          @conditionTypeChange="conditionTypeChange" @triggerEmitFun="triggerEmitFun"></TriggerList>
        <ExecutionAction :dateTypeList="dateTypeList" @executeEmitFun="executeEmitFun" ref="ExecutionAction"
          v-if="stepIndex == 2"></ExecutionAction>
        <EffectiveTime :timingTypeList="timingTypeList" :weekTypeList="weekTypeList" :triggerList="triggerList"
          :movementList="movementList" @effectiveTimeEmitFun="effectiveTimeEmitFun" ref="EffectiveTime"
          v-if="stepIndex == 3"></EffectiveTime>
      </div>
      <div class="bottom-btnview">
        <div class="item" v-if="stepIndex > 1" @click="stepClick('prev')">
          上一步
        </div>
        <div class="item item2" v-if="stepIndex < 3" @click="stepClick('next')">
          下一步
        </div>
        <div class="item item2" v-else @click="stepClick('next')">完成</div>
      </div>
    </div>
    <Msg ref="tsmsg"></Msg>
  </el-drawer>
</template>

<script>
import Step from "./components/step.vue";
import TriggerList from "./components/triggerList.vue";
import ExecutionAction from "./components/executionAction.vue";
import EffectiveTime from "./components/effectiveTime.vue";
import Msg from "@/components/msg.vue"; //信息提示组件
export default {
  props: ["triggerTypeList", "timingTypeList", "weekTypeList", "dateTypeList"],
  components: { Step, TriggerList, ExecutionAction, EffectiveTime, Msg },
  data() {
    return {
      drawer: false,
      type: "0", //0 新增  1 编辑
      stepIndex: 3,
      conditions: "1", //0 || 1 &&
      triggerList: [
        // {
        //     "id": "32",
        //     "propertyName": "环境测试01",
        //     "propertyType": "cloud_scene_trigger",
        //     "operateType": "0",
        //     "productType": "1",
        //     "propertyList": [
        //         {
        //             "id": "123",
        //             "propertyKey": "WD",
        //             "propertyValue": "",
        //             "deviceNum": "25050601000",
        //             "deviceSubNum": "s_0",
        //             "deviceCompNum": "25050601000",
        //             "sort": 1
        //         },
        //         {
        //             "id": "1223",
        //             "propertyKey": "WD",
        //             "propertyValue": "",
        //             "deviceNum": "25050601000",
        //             "deviceSubNum": "s_0",
        //             "deviceCompNum": "25050601000",
        //             "sort": 1
        //         }
        //     ]
        // }
      ], //触发条件列表
      movementList: [], //执行动作列表
      effectiveTimeObj: {
        efficientProperty: "",
        efficientType: "",
        efficientData: {
          startTime: "",
          endTime: "",
          type: "",
        },
      },
      sceneName: "",
      id:"",
    };
  },
  computed: {
    title() {
      if (this.type == "0") {
        return "新增";
      } else {
        return "编辑";
      }
    },
  },
  methods: {
    // 步骤点击
    stepClick(type) {
      if (type == "prev") {
        if (this.stepIndex == 1) {
          return;
        }
        this.stepIndex--;
        if (this.stepIndex == 2) {
          // 获取控制设备树形列表
          if (!this.movementList.length) {
            this.$nextTick(() => {
              this.$refs.ExecutionAction.getdeviceTree();
            });
          } else {
            this.$nextTick(() => {
              this.$refs.ExecutionAction.getdeviceTree(this.movementList);
            });
          }
        }
        if (this.stepIndex == 1) {


        }
      }
      if (type == "next") {
        if (this.stepIndex == 3) {
          let res = this.$refs.EffectiveTime.submitYZ();
          if (res.code != 200) {
            this.$refs.tsmsg.msgShow(res.msg, 1.5);
            return
          }
          return;
        }
        if (this.stepIndex == 1) {
          if (!this.triggerList.length) {
            this.$refs.tsmsg.msgShow("请添加触发条件", 1.5);
            return;
          }
        }
        if (this.stepIndex == 2) {
          let res = this.$refs.ExecutionAction.submitYZ();
          if (res.code != 200) {
            this.$refs.tsmsg.msgShow(res.msg, 1.5);
            return
          }
        }
        this.stepIndex++;
        if (this.stepIndex == 2) {
          // 获取控制设备树形列表
          if (!this.movementList.length) {
            this.$nextTick(() => {
              this.$refs.ExecutionAction.getdeviceTree();
            });
          } else {
            this.$nextTick(() => {
              this.$refs.ExecutionAction.getdeviceTree(this.movementList);
            });
          }
        }
        if (this.stepIndex == 3) {
          this.$nextTick(() => {
            console.log(this.$refs.EffectiveTime);
            this.effectiveTimeObj.sceneName = this.sceneName;
            this.$refs.EffectiveTime.initPage(this.effectiveTimeObj);
          })

        }
      }
    },
    // 触发条件改变
    conditionTypeChange(value) {
      this.conditions = value;
    },
    open(type, item) {
      this.type = type;
      this.drawer = true;
      this.stepIndex = 1;
      this.id=""
      this.conditions = "1";
      this.triggerList = [];
      this.movementList = [];
      this.effectiveTimeObj = {
        efficientProperty: "",
        efficientType: "",
        efficientData: {
          startTime: "",
          endTime: "",
          type: "",
        },
      };
      if (this.type == "0") {
        setTimeout(() => {
          this.$refs.TriggerList.radio = this.conditions;
        }, 300);
      } else {
        this.$http.getAction(this.$api.cloudscenedetails + "/" + item.id).then((res) => {
          if (res.data) {
            this.id = res.data.id;
            this.conditions = res.data.conditionType;
            this.effectiveTimeObj.efficientProperty = res.data.efficientProperty;
            this.effectiveTimeObj.efficientType = res.data.efficientType;
            if (res.data.efficientProperty == "1" || res.data.efficientType == "4") {
              res.data.efficientData = JSON.parse(res.data.efficientData)
              this.effectiveTimeObj.efficientData = res.data.efficientData
            }
            let triggerList = res.data.attributeMaps.cloud_scene_trigger;
            triggerList.forEach((item) => {
              item.name = item.propertyName;
              item.propertyList.forEach((ele) => {
                ele.propertyValue = JSON.parse(ele.propertyValue)
              })
            })
            let movementList = res.data.attributeMaps.cloud_scene_execute;
            movementList.forEach((item) => {
              item.name = item.propertyName;
              item.propertyList.forEach((ele) => {
                ele.propertyValue = JSON.parse(ele.propertyValue)
              })
            })
            this.triggerList = triggerList;
            this.movementList = movementList;
            setTimeout(() => {
              this.$refs.TriggerList.radio = this.conditions;
            }, 300);
            this.$forceUpdate()
          }

        })
      }
    },
    // 触发条件点击确定
    triggerEmitFun(obj) {
      console.log(obj);
      if (obj.type == "add") {
        obj.value.name = obj.value.propertyName;
        // obj.value.sensor = true;
        obj.value.sort = this.triggerList.length + 1;
        this.triggerList.push(obj.value);
      } else {
        if (obj.value.id) {
          this.triggerList.forEach((item) => {
            if (item.id && item.id == obj.value.id) {
              item.name = obj.value.propertyName;
              item.propertyName = obj.value.propertyName;
              item.propertyList[0].propertyValue.attributeKey =
                obj.value.propertyList[0].propertyValue.attributeKey;
              item.propertyList[0].propertyValue.attributeValue =
                obj.value.propertyList[0].propertyValue.attributeValue;
              if (obj.value.propertyList[0].propertyValue.attributeType) {
                item.propertyList[0].propertyValue.attributeType =
                  obj.value.propertyList[0].propertyValue.attributeType;
              }
            }
          });
        } else {
          this.triggerList.forEach((item) => {
            if (item.sort && item.sort == obj.value.sort) {
              item.name = obj.value.propertyName;
              item.propertyName = obj.value.propertyName;
              item.propertyList[0].propertyValue.attributeKey =
                obj.value.propertyList[0].propertyValue.attributeKey;
              item.propertyList[0].propertyValue.attributeValue =
                obj.value.propertyList[0].propertyValue.attributeValue;
              if (obj.value.propertyList[0].propertyValue.attributeType) {
                item.propertyList[0].propertyValue.attributeType =
                  obj.value.propertyList[0].propertyValue.attributeType;
              }
            }
          });
        }
        this.$forceUpdate();
      }
    },
    // 执行动作回调
    executeEmitFun(obj) {
      obj.forEach((item,index)=>{
        item.sort = index+1
      })
      console.log(obj);
      
      this.movementList = obj;
    },
    // 触发时间回调
    effectiveTimeEmitFun(obj) {
      this.effectiveTimeObj = JSON.parse(JSON.stringify(obj));
      this.sceneName = obj.sceneName;
      delete this.effectiveTimeObj.sceneName;
      let params = {
        conditionType: this.conditions,
        efficientData: this.effectiveTimeObj.efficientData,
        efficientType: this.effectiveTimeObj.efficientType,
        efficientProperty: this.effectiveTimeObj.efficientProperty,
        sceneName: this.sceneName,
        attributeMaps: {
          cloud_scene_trigger: this.triggerList,
          cloud_scene_execute: this.movementList
        }
      }
      if (this.id) {
        params.id = this.id;
      }
      params = JSON.parse(JSON.stringify(params))
      if (params.efficientProperty == "0" && params.efficientType != "4") {
        params.efficientData = "00:00"
      } else {
        params.efficientData = JSON.stringify(params.efficientData)
      }
      params.attributeMaps.cloud_scene_trigger.forEach((item) => {
        item.propertyList.forEach((ele) => {
          ele.propertyValue = JSON.stringify(ele.propertyValue)
        })
      })
      params.attributeMaps.cloud_scene_execute.forEach((item) => {
        item.propertyList.forEach((ele) => {
          ele.propertyValue = JSON.stringify(ele.propertyValue)
        })
      })
      this.$http.postAction(this.$api.cloudscenesaveOrUpdate, params).then((res) => {
        if (res.code != 200) {
          this.$refs.tsmsg.msgShow(res.msg, 1.5);
          return;
        }
        this.$refs.tsmsg.msgShow("设置成功", 1.5);
        setTimeout(() => {
          this.drawer = false;
          this.$emit("Loaddata")
        }, 500)
      })
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cloudsceneDrawer {
  border-radius: 0.225rem 0px 0px 0.225rem;

  .el-drawer__header {
    height: 0.625rem;
    box-sizing: border-box;
    text-align: left;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #454545;
    padding-top: 0;
    border-bottom: 1px solid #f1f1f1;

    span {
      font-size: 0.225rem;
    }
  }

  .el-drawer__close-btn {
    color: #454545;
  }

  .el-drawer__body {
    padding: 0 0.3rem 0.25rem;
    display: flex;
    flex-direction: column;

    .drawer-view {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      padding-bottom: 0.5rem;
      padding-top: 0.5rem;
    }

    .center-view {
      margin-top: 0.875rem;
      margin-bottom: 0.75rem;
      flex: 1;
      border: 1px dashed #2daea9;
      overflow: auto;
    }

    .bottom-btnview {
      height: 0.45rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .item {
        margin: 0 0.0875rem;
        cursor: pointer;
        width: 1.4625rem;
        height: 0.45rem;
        border-radius: 0.05rem;
        border: 1px solid #2daea9;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 0.175rem;
        color: #2daea9;
      }

      .item2 {
        background: #2daea9;
        color: #feffff;
      }
    }
  }
}
</style>